import type { TriggerStateRow } from '@axilon-apps/domains-ontology-ui-state'

export type TriggerDisplayState =
  | 'normal'
  | 'pending_activation'
  | 'active'
  | 'pending_clear'
  | 'active_stale'
  | 'unavailable'

export interface TriggerStateDisplay {
  state: TriggerDisplayState
  label:
    | 'Normal'
    | 'Pending activation'
    | 'Active'
    | 'Pending clear'
    | 'Active/data stale'
    | 'Unavailable'
}

export function deriveStoredTriggerDisplay(row: TriggerStateRow | undefined): TriggerStateDisplay {
  if (!row) return { state: 'unavailable', label: 'Unavailable' }
  const dataUnavailable =
    row.stale === true ||
    row.is_good === false ||
    row.last_observation === 'unknown' ||
    row.last_observation === 'error'
  const remainsActive = row.phase === 'active' || row.phase === 'pending_off'

  if (dataUnavailable) {
    return remainsActive
      ? { state: 'active_stale', label: 'Active/data stale' }
      : { state: 'unavailable', label: 'Unavailable' }
  }
  switch (row.phase) {
    case 'pending_on':
      return { state: 'pending_activation', label: 'Pending activation' }
    case 'active':
      return { state: 'active', label: 'Active' }
    case 'pending_off':
      return { state: 'pending_clear', label: 'Pending clear' }
    case 'inactive':
      return { state: 'normal', label: 'Normal' }
  }
}

export function pendingTiming(row: TriggerStateRow): {
  elapsedMs: number
  targetMs?: number
} | null {
  if (row.phase !== 'pending_on' && row.phase !== 'pending_off') return null
  const delay = row.phase === 'pending_on' ? row.on_delay_seconds : row.off_delay_seconds
  return {
    elapsedMs: Math.max(0, row.pending_elapsed_ms ?? 0),
    targetMs: delay === undefined ? undefined : Math.max(0, delay * 1000)
  }
}
